
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cpPawnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cp_baseline"},"name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"cpPawnId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"deploymentHandle"},"value":{"kind":"StringValue","value":"cp_baseline","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"applyPawnContext"},"value":{"kind":"BooleanValue","value":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sm_age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_sex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_gender_raw"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_branch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cp_anxiety_score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cp_depression_score"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sm_baseline"},"name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"deploymentHandle"},"value":{"kind":"StringValue","value":"sm_baseline","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sm_age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_sex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_gender_raw"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_branch"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sm_intervention"},"name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"deploymentHandle"},"value":{"kind":"StringValue","value":"sm_intervention","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sm_drinks_per_day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_drinks_per_day_estimation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_days_binge_drinking"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm_days_binge_drinking_estimation"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":966}};
    doc.loc.source = {"body":"query($pawnId: Int, $cpPawnId: Int) {\n    flows(as: ANY) {\n        cp_baseline: assignmentProgress(pawnId: [$cpPawnId], deploymentHandle: \"cp_baseline\", applyPawnContext: false) {\n            devTags {\n                sm_age\n                sm_sex\n                sm_gender_raw\n                sm_branch\n\n                cp_anxiety_score\n                cp_depression_score\n            }\n        }\n\n        sm_baseline: assignmentProgress(pawnId: [$pawnId], deploymentHandle: \"sm_baseline\") {\n            devTags {\n                sm_age\n                sm_sex\n                sm_gender_raw\n                sm_branch\n            }\n        }\n\n        sm_intervention: assignmentProgress(pawnId: [$pawnId], deploymentHandle: \"sm_intervention\") {\n            devTags {\n                sm_drinks_per_day\n                sm_drinks_per_day_estimation\n                sm_days_binge_drinking\n                sm_days_binge_drinking_estimation\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
